export class ListaPreciosVentaGeneral{

	public SALES_PRICE_LIST_GENERAL_ID: number;
	public COMPANY_ID: number;
	public NAME: string;
	public SALES_PRICE_LIST_TYPE_ID: number;
	public DESTINATION_ID: number;
	public START_DATE: Date;
	public END_DATE: Date;
	public CREATION_DATE: Date;
	public CREATED_BY: number;
	public LAST_UDPATE_DATE: Date;
	public LAST_UPDATED_BY: number;
	public ENABLED: boolean;

	constructor(){
		this.SALES_PRICE_LIST_GENERAL_ID = null;
		this.COMPANY_ID = null;
		this.NAME = null;
		this.SALES_PRICE_LIST_TYPE_ID = null;
		this.DESTINATION_ID = null;
		this.START_DATE = null;
		this.END_DATE = null;
		this.CREATION_DATE = null;
		this.CREATED_BY = null;
		this.LAST_UDPATE_DATE = null;
		this.LAST_UPDATED_BY = null;
		this.ENABLED = null;
	}

}


// WEBPACK FOOTER //
// ./src/app/models/ListaPreciosVentaGeneral.ts